import { useEffect } from 'react';
import scopeLogger from 'lib/scope-logger.js';

const FULLSCREEN = 'fullscreen';
const console = scopeLogger('RMI:creative:use-styles');

export default function useSchemaStyle(schema) {
  useEffect(() => {
    if (!schema) {
      return;
    }
    performance.mark('useSchemaStyle');

    const styleEl = document.createElement('style');
    document.head.appendChild(styleEl);
    const styleSheet = styleEl.sheet;
    const insertRule = (rule) => {
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    };

    schema.style.forEach(([selector, properties, media]) => {
      const propStr = properties.reduce(
        (str, [name, value]) => str + `${name}: ${value};`,
        '',
      );
      let rule = `${selector}{${propStr}}`;
      if (media) {
        rule = `${media}{${rule}}`;
      }
      insertRule(rule);
    });

    // TODO: instead insert size based styles generate it as part processing in `generate-styles.js`
    schema.size.forEach((variant) => {
      const selector = `article > div[data-display-mode=${FULLSCREEN}]`;
      let rule = `
				${selector} {
					position: relative;
					width: 100%;
					height: intrinsic;
					max-height: 100%;
					aspect-ratio: ${variant.aspectRatio}
				}`;

      /* STV does not require such instruction */
      let subRule = `@media (min-aspect-ratio: ${variant.aspectRatio}) {
					.web ${selector}, .mobile ${selector} {
					  width: unset;
						height: 100%;
					}
				}`;

      /**
       * Fallback for aspect-ratio
       * @see {@link https://css-tricks.com/aspect-ratio-boxes/#aa-the-pseudo-element-tactic source}
       */
      let fallbackRule = `
				@supports not (aspect-ratio: ${variant.aspectRatio}) {
				  ${selector} {
            position: static;
          }
					${selector}::before {
						content: "";
						width: 1px;
						margin-left: -1px;
						float: left;
						height: 0;
						padding-top: calc(${variant.aspectRatio} * 100%);
					}
					${selector}::after {
						content: "";
						display: table;
						clear: both;
					}
				}`;

      if (variant.orientation) {
        rule = `@media screen and (orientation: ${variant.orientation}) {${rule}}`;
        fallbackRule = `@media screen and (orientation: ${variant.orientation}) {${fallbackRule}}`;
      }

      insertRule(rule);
      insertRule(subRule);
      insertRule(fallbackRule);
    });

    const measure = performance.measure('useSchemaStyle', 'useSchemaStyle');

    console.log('useSchemaStyle', measure);

    console.dir(styleSheet.cssRules);

    return () => {
      document.head.removeChild(styleEl);
    };
  }, [schema]);
}
